import { MinusSquareFilled, PlusSquareFilled } from "@ant-design/icons";
import { AutoComplete, Col, Form, Input, Row, Space, Tooltip } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-phone-input-2/lib/style.css";
import { debounce } from "lodash";
import "../../styles/Main.scss";
// import { LoadScript } from "@react-google-maps/api";
// import Map from "./Map";
import { authUserData } from "../../utils/Helper";

const EndLocationAddress = ({ state, setState, companyId, data }) => {
  const { t } = useTranslation();
  const colors = ["#0000"];
  // const [apiLoading, setapiloading] = useState(false);
  // const libraries = ["places"];
  const formRef = useRef();
  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [addresses, setaddresses] = useState([
  //     { end_street_address: '', end_suburb: '', end_state: '', end_postcode: '', end_additional_details: '' },
  // ]);
  // Function to handle input changes for key person fields
  // const handleCloneInputChange = (field, e, index) => {
  //     let newPersonArr = state.addresses;
  //     newPersonArr[index][field] = e.target.value ? e.target.value : null;
  //     setState({ ...state, addresses: newPersonArr });
  // };

  // Function to remove a key person from the list
  // const removePerson = async (lastIndex) => {
  //     let filterPersonArr = state.addresses.filter(
  //         (item, index) => index !== lastIndex
  //     );
  //     setState({ ...state, addresses: filterPersonArr });
  //     setWeightSizeFieldValue(filterPersonArr);
  // };
  const removePerson = (index) => {
    // Create a new array excluding the person at the specified index
    const newaddresses = state.addresses.filter((_, i) => i !== index);

    // Update the state with the new addresses array
    setState((prevState) => ({
      ...prevState,
      addresses: newaddresses,
    }));

    // Prepare to reset fields for all subsequent persons
    const resetFields = {};

    // Reset fields for all remaining persons after the removed index
    newaddresses.forEach((_, i) => {
      resetFields[`end_street_address${i}`] =
        newaddresses[i].end_street_address || "";
      resetFields[`end_suburb${i}`] = newaddresses[i].end_suburb || "";
      resetFields[`end_state${i}`] = newaddresses[i].end_state || "";
      resetFields[`end_postcode${i}`] = newaddresses[i].end_postcode || "";
      resetFields[`end_additional_details${i}`] =
        newaddresses[i].end_additional_details || "";
    });

    // Set form values for the remaining fields
    form.setFieldsValue(resetFields);
  };
  const handleSearch = useCallback(
    (index) =>
      debounce((value) => {
        // Implement the Google Places API logic
        const service = new window.google.maps.places.AutocompleteService();

        if (value !== "") {
          service.getPlacePredictions(
            { input: value },
            (predictions, status) => {
              if (
                status === window.google.maps.places.PlacesServiceStatus.OK &&
                predictions
              ) {
                setOptions(
                  predictions.map((prediction) => ({
                    value: prediction.description,
                    place_id: prediction.place_id,
                  }))
                );
              } else {
                setOptions([]);
              }
            }
          );
        } else {
          // Clear the corresponding address fields
          const newAddresses = [...state.addresses];
          newAddresses[index] = {
            end_street_address: null,
            end_suburb: null,
            end_state: null,
            end_postcode: null,
            end_additional_details: null,
            // coordinates: { latitude: null, longitude: null },
          };
          setState((prev) => ({ ...prev, addresses: newAddresses }));
          form.setFieldsValue({
            [`end_street_address${index}`]: null,
            [`end_suburb${index}`]: null,
            [`end_state${index}`]: null,
            [`end_postcode${index}`]: null,
          });
        }
      }, 300),
    [state.addresses, form]
  );

  // const handleSearch = useCallback(
  //     (index) => debounce((value) => {
  //         // Implement the Google Places API logic
  //         const service = new window.google.maps.places.AutocompleteService();

  //         if (value !== "") {
  //             service.getPlacePredictions({ input: value }, (predictions, status) => {
  //                 if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
  //                     setOptions(predictions.map((prediction) => ({
  //                         value: prediction.description,
  //                         place_id: prediction.place_id,
  //                     })));
  //                 } else {
  //                     setOptions([]);
  //                 }
  //             });
  //         }
  //         // else {
  //         //     // Clear the corresponding address fields
  //         //     const newAddresses = [...state.addresses];
  //         //     newAddresses[index] = [  { end_street_address: null, end_suburb: null, end_state: null, end_postcode: null, end_additional_details: null }]; // Reset address at this index
  //         //     setState((prev) => ({ ...prev, addresses: [   { end_street_address: null, end_suburb: null, end_state: null, end_postcode: null, end_additional_details: null }] }));
  //         // }
  //     }, 300),
  //     [state.end_street_address]
  // );

  // const handleSelect = (index) => (value) => {
  //     const selected = options.find((option) => option.value === value);
  //     if (selected && selected.place_id) {
  //         const service = new window.google.maps.places.PlacesService(document.createElement("div"));
  //         service.getDetails({ placeId: selected.place_id }, (place, status) => {
  //             if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
  //                 const newAddresses = [...state.addresses];
  //                 newAddresses[index] = {
  //                     end_street_address: place.formatted_address,
  //                     end_suburb: place.address_components.find((ac) => ac.types.includes("locality"))?.long_name || "",
  //                     end_state: place.address_components.find((ac) => ac.types.includes("administrative_area_level_1"))?.short_name || "",
  //                     end_postcode: place.address_components.find((ac) => ac.types.includes("postal_code"))?.long_name || "",
  //                 };
  //                 setState((prev) => ({ ...prev, addresses: newAddresses }));
  //                 form.setFieldsValue({
  //                     [`end_street_address${index}`]: place.formatted_address,
  //                     [`end_suburb${index}`]: newAddresses[index].end_suburb,
  //                     [`end_state${index}`]: newAddresses[index].end_state,
  //                     [`end_postcode${index}`]: newAddresses[index].end_postcode,
  //                 });
  //             }
  //         });
  //     }
  // };

  // Function to set the values of the form fields based on the addresses data

  const handleSelect = (index) => (value) => {
    if (!value) {
      // Clear the corresponding address fields
      const newAddresses = [...state.addresses];
      newAddresses[index] = {
        end_street_address: null,
        end_suburb: null,
        end_state: null,
        end_postcode: null,
        end_additional_details: null,
        // coordinates: { latitude: null, longitude: null },
      };
      setState((prev) => ({ ...prev, addresses: newAddresses }));
      form.setFieldsValue({
        [`end_street_address${index}`]: null,
        [`end_suburb${index}`]: null,
        [`end_state${index}`]: null,
        [`end_postcode${index}`]: null,
      });
      return;
    }

    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          const newAddresses = [...state.addresses];
          newAddresses[index] = {
            end_street_address: place.formatted_address,
            end_suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            end_state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            end_postcode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
            // coordinates: {
            //   latitude: place.geometry?.location?.lat() || null,
            //   longitude: place.geometry?.location?.lng() || null,
            // },
          };
          setState((prev) => ({ ...prev, addresses: newAddresses }));
          form.setFieldsValue({
            [`end_street_address${index}`]: place.formatted_address,
            [`end_suburb${index}`]: newAddresses[index].end_suburb,
            [`end_state${index}`]: newAddresses[index].end_state,
            [`end_postcode${index}`]: newAddresses[index].end_postcode,
          });
        }
      });
    }
  };

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};

    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["end_street_address" + objectKey] =
        objectValue.end_street_address;
      fieldObject["end_suburb" + objectKey] = objectValue.end_suburb;
      fieldObject["end_state" + objectKey] = objectValue.end_state;
      fieldObject["end_postcode" + objectKey] = objectValue.end_postcode;
      fieldObject["end_additional_details" + objectKey] =
        objectValue.end_additional_details;

      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };

  // Function to add a new key person to the list
  // const addPerson = () => {
  //     let newPersonArr = [
  //         ...state.addresses,
  //         {
  //             street_address: null,
  //             suburb: null,
  //             state: null,
  //             postcode: null,
  //             additional_details: null,
  //         },
  //     ];
  //     setState({ ...state, addresses: newPersonArr });
  //     setWeightSizeFieldValue(newPersonArr);
  // };
  const addPerson = () => {
    const newPerson = {
      end_street_address: "",
      end_suburb: "",
      end_state: "",
      end_postcode: "",
      end_additional_details: "",
    };

    // Update the state with the new key person
    setState((prevState) => {
      const updatedaddresses = [...prevState.addresses, newPerson];

      // Prepare to set form fields for the new person
      const newIndex = updatedaddresses.length - 1; // Get the index of the new person
      const resetFields = {
        [`end_street_address${newIndex}`]: "",
        [`end_suburb${newIndex}`]: "",
        [`end_state${newIndex}`]: "",
        [`end_postcode${newIndex}`]: "",
        [`end_additional_details${newIndex}`]: "",
      };

      // Set form fields to empty for the new person
      form.setFieldsValue(resetFields);

      // Return the updated state
      return {
        ...prevState,
        addresses: updatedaddresses,
      };
    });
  };

  // Function to handle phone number input changes for key persons
  // const handleClonePhoneInputChange = (field, phone, index) => {
  //     let newPersonArr = state.addresses;
  //     newPersonArr[index][field] = phone ? phone : null;
  //     setState({ ...state, addresses: newPersonArr });
  // };

  // useEffect hook to update form fields when the component mounts or when state, companyId, or t changes
  useEffect(() => {
    //if (companyId) {
    const modifiedInquiry = state.addresses.map((inquiryDetail) => {
      const { id, company, company_name, ...rest } = inquiryDetail;
      return rest;
    });

    setWeightSizeFieldValue(modifiedInquiry);
    //}
  }, [state, companyId, t]);

  return (
    // <LoadScript
    //     googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
    //     libraries={libraries}
    // >

    <Form onFinish={""} autoComplete="off" form={form} ref={formRef}>
      {state.addresses &&
        state.addresses.map((x, index) => {
          return (
            <>
              <Row gutter={10} key={index} className="customcol">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="street_address"
                    name={`end_street_address` + index}
                    label={t("street_address")}
                  >
                    <AutoComplete
                      id="end_street_address"
                      placeholder={t("pl_street_address")}
                      options={options}
                      onSearch={handleSearch(index)} // Pass index to handleSearch
                      onSelect={handleSelect(index)} // Pass index to handleSelect
                      value={state.addresses[index].end_street_address}
                      onChange={(value) => {
                        const newaddresses = [...state.addresses];
                        newaddresses[index].end_street_address = value;
                        setState({ ...state, addresses: newaddresses });
                        form.setFieldsValue({
                          [`end_street_address${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="suburb"
                    name={`end_suburb` + index}
                    label={t("pl_suburb")}
                  >
                    <Input
                      placeholder={t("pl_enter_suburb")}
                      // name="suburb"
                      value={state.addresses[index].end_suburb}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newaddresses = [...state.addresses];
                        newaddresses[index].end_suburb = value;
                        setState({ ...state, addresses: newaddresses });
                        form.setFieldsValue({
                          [`end_suburb${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="state"
                    name={`end_state` + index}
                    label={t("pl_state")}
                  >
                    <Input
                      placeholder={t("pl_enter_state")}
                      // name="state"
                      value={state.addresses[index].end_state}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newaddresses = [...state.addresses];
                        newaddresses[index].end_state = value;
                        setState({ ...state, addresses: newaddresses });
                        form.setFieldsValue({
                          [`end_state${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <Form.Item
                    // name="postcode"
                    name={`end_postcode` + index}
                    label={t("pl_Postcode")}
                  >
                    <Input
                      placeholder={t("pl_enter_postcode")}
                      // name="postcode"
                      value={state.addresses[index].end_postcode}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newaddresses = [...state.addresses];
                        newaddresses[index].end_postcode = value;
                        setState({ ...state, addresses: newaddresses });
                        form.setFieldsValue({
                          [`end_postcode${index}`]: value,
                        });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  //   className="TextFeild"
                >
                  <Form.Item
                    // name="additional_details"
                    name={`end_additional_details` + index}
                    label={t("additional_details")}
                  >
                    <Input
                      placeholder={t("enter_additional_details")}
                      // name="additional_details"
                      value={state.addresses[index].end_additional_details}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newaddresses = [...state.addresses];
                        newaddresses[index].end_additional_details = value;
                        setState({ ...state, addresses: newaddresses });
                        form.setFieldsValue({
                          [`end_additional_details${index}`]: value,
                        });
                      }}
                      // Adjust the number of rows as needed
                    />
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={4}
                  xl={4}
                  className="TextFeild"
                >
                  <div
                    className="addwrp"
                    style={{ margin: 0, marginTop: "22px" }}
                  >
                    <Space>
                      {index !== 0 ? (
                        // <Tooltip
                        //   color={colors}
                        //   title={
                        //     <span style={{ color: "#000000" }}>
                        //       Remove Depo Address
                        //     </span>
                        //   }
                        // >
                        <>
                          {authUserData()?.permission.includes(
                            "company|delete_depoaddress"
                          ) && (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removePerson(index)}
                            />
                          )}
                        </>
                      ) : (
                        // </Tooltip>
                        ""
                      )}
                      {/* <Tooltip
                        color={colors}
                        title={
                          <span style={{ color: "#000000", mar: "20px" }}>
                            Add Depo Address
                          </span>
                        }
                      > */}
                      {authUserData()?.permission.includes(
                        "company|add_depoaddress"
                      ) && (
                        <PlusSquareFilled
                          className="add"
                          onClick={(e) => addPerson(e)}
                        />
                      )}
                      {/* </Tooltip> */}
                    </Space>
                  </div>
                </Col>
              </Row>
            </>
          );
        })}
    </Form>

    // </LoadScript>
  );
};
EndLocationAddress.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  companyId: PropTypes.number,
  data: PropTypes.func,
};
export default EndLocationAddress;
